import React, { useState } from 'react';
import { GoogleLogin, googleLogout } from '@react-oauth/google';
import jwt_decode from 'jwt-decode';
import { useApiRequests } from '../../services/fetchApiServices/index';
import { NotificationPopup } from '../../common';

const NO_ACCOUNT_MESSAGE =
  "No Kudos Shop account was found for this email. Please contact your administrator to request access.";
const SIGN_IN_ERROR_MESSAGE =
  "We couldn't sign you in right now. Please try again in a moment.";
const GOOGLE_ERROR_MESSAGE = "Google sign-in failed. Please try again.";

// Backend ResponseCodes.AccountNotProvisioned (KudoShop_DataLayer ResponseDictionary):
// returned as HTTP 403 when Google authenticated the user but no Kudos Shop account
// exists for the email. Distinct from an invalid/expired token (401).
const ACCOUNT_NOT_PROVISIONED_CODE = 23;

export const GoogleAuthForm = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const apiRequests = useApiRequests();

  const handleSuccess = async (credentialResponse) => {
    setErrorMessage("");
    localStorage.setItem(
      "token",
      JSON.stringify(credentialResponse.credential)
    );

    const userObject = jwt_decode(credentialResponse.credential);

    try {
      // Suppress the global error toast so only the inline message below shows.
      const User = await apiRequests.getUserByEmail(userObject.email, {
        suppressErrorToast: true,
      });
      if (User && User.data) {
        localStorage.setItem('userType', User.data.type);
        setIsAuthenticated(true);
        window.location.replace('/');
      } else {
        // Google authenticated the user, but there is no matching Kudos account.
        handleLogout();
        setErrorMessage(NO_ACCOUNT_MESSAGE);
      }
    } catch (error) {
      // The backend returns 403 + code AccountNotProvisioned when the email has no
      // Kudos Shop account; anything else is a server/network issue.
      handleLogout();
      const isNoAccount =
        error.response?.data?.code === ACCOUNT_NOT_PROVISIONED_CODE ||
        error.response?.status === 403;
      setErrorMessage(isNoAccount ? NO_ACCOUNT_MESSAGE : SIGN_IN_ERROR_MESSAGE);
    }
  };

  const onLogoutSuccess = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userType');
    setIsAuthenticated(false);
  };

  const handleError = () => {
    setErrorMessage(GOOGLE_ERROR_MESSAGE);
  };

  const handleLogout = () => {
    googleLogout();
    onLogoutSuccess();
  };

  return (
    <section className="py-24 py-lg-36">
      <div className="text-center mx-auto px-3">
        <h2 className="mb-12 mt-6">Sign In to your account</h2>
        <NotificationPopup
          isPopupOpen={!!errorMessage}
          type="error"
          message={errorMessage}
        />
        <div className="d-flex justify-content-center">
          {isAuthenticated ? (
            <button onClick={handleLogout}>Logout</button>
          ) : (
            <GoogleLogin
              onSuccess={handleSuccess}
              onError={handleError}
              render={(renderProps) => (
                <button className="" onClick={renderProps.onClick}></button>
              )}
            />
          )}
        </div>
      </div>
    </section>
  );
};
